/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

import useToast from '../../../hooks/useToast';
import { getBusinessUnits, getEvents, typeUbicationSS } from '../../../services/yclickMaster';
import {
  workPartStatusOptionsForInspector,
  workPartStatusOptionsForAproover
} from '../../../services/serviceRequest';

const useFilterParams = (isInspector, includeGenericTypes = false) => {
  const { setNewToast } = useToast();
  const [ubicationTypeSelect, setUbicationTypeSelect] = useState([]);
  const [events, setEvents] = useState([]);
  const [workPartStatus, setWorkPartStatus] = useState([]);
  const [userBusinessUnits, setUserBusinessUnits] = useState([]);
  const getParams = async () => {
    try {
      const ubicationTypeResult = await typeUbicationSS(includeGenericTypes);

      setUbicationTypeSelect(ubicationTypeResult);

      const eventOptions = await getEvents({ sinAsignacion: false });

      setEvents(eventOptions);

      const promise = isInspector
        ? workPartStatusOptionsForInspector
        : workPartStatusOptionsForAproover;

      const workPartStatusOpts = await promise();

      setWorkPartStatus(workPartStatusOpts);

      const businessUnitResult = await getBusinessUnits();

      setUserBusinessUnits(businessUnitResult.map((e) => e.id));
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  useEffect(() => {
    getParams();
  }, []);

  return {
    ubicationTypeSelect,
    events,
    workPartStatus,
    userBusinessUnits
  };
};

export default useFilterParams;
